"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _ShopContext = require("../context/ShopContext");

var useBasket = function useBasket() {
  var _useContext = (0, _react.useContext)(_ShopContext.store),
      basket = _useContext.basket,
      basketAdd = _useContext.basketAdd,
      basketRemove = _useContext.basketRemove,
      basketToggle = _useContext.basketToggle,
      basketClear = _useContext.basketClear,
      basketError = _useContext.basketError,
      basketLoading = _useContext.basketLoading,
      basketComplete = _useContext.basketComplete,
      basketProducts = _useContext.basketProducts,
      basketNotFound = _useContext.basketNotFound,
      requestBasketProducts = _useContext.requestBasketProducts,
      BASKET_MAX = _useContext.BASKET_MAX;

  (0, _react.useEffect)(function () {
    if (basketComplete && basketNotFound !== null && basketNotFound !== void 0 && basketNotFound.length) {
      basketRemove(basketNotFound);
    }
  }, [basketComplete, basketNotFound, basketRemove]);
  var basketLoadProducts = (0, _react.useCallback)(function () {
    requestBasketProducts(basket);
  }, [requestBasketProducts, basket]);
  return [{
    basket: basket,
    basketError: basketError,
    basketLoading: basketLoading,
    basketComplete: basketComplete,
    basketProducts: basketProducts,
    basketNotFound: basketNotFound,
    requestBasketProducts: requestBasketProducts,
    BASKET_MAX: BASKET_MAX
  }, {
    basketAdd: basketAdd,
    basketRemove: basketRemove,
    basketToggle: basketToggle,
    basketClear: basketClear,
    basketLoadProducts: basketLoadProducts
  }];
};

var _default = useBasket;
exports["default"] = _default;